import { HOTEL_LFAR_ROUTE } from '../../../router/constants';
import { App } from './App';

export const HOTEL_LFAR = {
  path: HOTEL_LFAR_ROUTE,
  element: <App />,
};
